import { assertNever } from '@kofno/piper';
import { just, Maybe, nothing } from 'maybeasy';
import { action, computed, makeObservable, observable } from 'mobx';
import { error } from '../ErrorHandling';
import { TPlainTextKey } from '../Translations';
import { errorAlert, FlashAlert } from '../Notifications/Types';
import {
  loading,
  ready,
  State,
  VisualizationFunction,
  VisualizationTokenResource,
  waiting,
} from './Types';
import {
  quickSightVizFn,
  QuickSightVisualization,
} from '../components/Visualization/quickSightEmbedAPILoader';

class VisualizationTokenStore {
  @observable state: State = waiting();
  visualizationFn: VisualizationFunction = (): QuickSightVisualization => ({});
  quickSightVisualizationFn: quickSightVizFn = (): QuickSightVisualization => ({});

  constructor() {
    makeObservable(this);
  }

  @action
  loading = () => {
    switch (this.state.kind) {
      case 'waiting':
      case 'ready':
        this.state = loading();
        break;
      case 'loading':
      case 'error':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  ready = (
    visualizationTokenResource: VisualizationTokenResource,
    visualizationFn: VisualizationFunction,
  ) => {
    switch (this.state.kind) {
      case 'waiting':
      case 'loading':
        this.visualizationFn = visualizationFn;
        this.state = ready(visualizationTokenResource.payload);
        break;
      case 'ready':
      case 'error':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  error = (msg: TPlainTextKey) => {
    switch (this.state.kind) {
      case 'waiting':
        break;
      case 'loading':
      case 'ready':
        this.state = error(msg);
        break;
      case 'error':
        break;
      default:
        assertNever(this.state);
    }
  };

  @computed
  get notification(): Maybe<FlashAlert> {
    switch (this.state.kind) {
      case 'error':
        return just(this.state).map(errorAlert);
      case 'ready':
      case 'loading':
      case 'waiting':
        return nothing();
    }
  }
}

export default VisualizationTokenStore;
